import { Component, Input } from '@angular/core';

/**
 * Tile de KPI: valor grande + label, com variante de cor opcional.
 * Substitui a faixa de KPIs do mockup (não confundir com o <chart-simple>,
 * que formata sempre como moeda e é usado no dashboard por IdType=1).
 */
@Component({
	selector: 'stat-tile',
	templateUrl: './stat-tile.component.html',
	styleUrls: ['./stat-tile.component.scss'],
})
export class StatTileComponent {

	/** Valor já formatado a apresentar (ex.: "83%", "47 anos", "750 371,27 €"). */
	@Input('value') Value: string | number = '--';

	/** Legenda por baixo do valor. */
	@Input('label') Label: string = '';

	/** Variante de cor do valor: 'pos' | 'neg' | 'warn' | '' (neutro). */
	@Input('variant') Variant: 'pos' | 'neg' | 'warn' | '' = '';

	/** Variação opcional vs período anterior (ex.: "▲ 12%"). */
	@Input('delta') Delta: string = '';

	/** Cor da variação: 'pos' (verde) | 'neg' (vermelho) | '' (neutro). */
	@Input('deltaKind') DeltaKind: 'pos' | 'neg' | '' = '';

	/** Mini-série (sparkline) opcional. Desenhada como polyline SVG no rodapé do tile. */
	@Input('spark') Spark: number[] | null = null;

	/** True se há série suficiente para desenhar a sparkline. */
	public get HasSpark(): boolean {
		return !!this.Spark && this.Spark.length >= 2;
	}

	/** Pontos da polyline normalizados a uma viewBox 100×24 (sem eixos — só a forma da tendência). */
	public get SparkPoints(): string {
		const d = this.Spark;
		if (!d || d.length < 2) return '';
		const max = Math.max(...d);
		const min = Math.min(...d);
		const range = (max - min) || 1;
		const w = 100, h = 24, n = d.length;
		return d.map((v, i) => `${((i / (n - 1)) * w).toFixed(1)},${(h - ((v - min) / range) * h).toFixed(1)}`).join(' ');
	}

	/** True se a série termina acima de onde começou (tendência ascendente → cor positiva). */
	public get SparkUp(): boolean {
		const d = this.Spark;
		return !!d && d.length >= 2 && d[d.length - 1] >= d[0];
	}

}
